import { render, staticRenderFns } from "./UiTransitionFade.vue?vue&type=template&id=6c544a08&"
import script from "./UiTransitionFade.vue?vue&type=script&lang=js&"
export * from "./UiTransitionFade.vue?vue&type=script&lang=js&"
import style0 from "./UiTransitionFade.vue?vue&type=style&index=0&id=6c544a08&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports